module.exports = __webpack_public_path__ + "static/media/design.c5bd08d0.png";